const DIETS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default DIETS_INITIAL_STATE
